import request from '@utils/request';
import { FILTER_DATE_ENUM } from './cash.constants';
import { getStartUnix, getEndUnix } from '../../utils/helper';

export function getCashIncomeApi(filter = {}) {
  const params = { ...filter };
  if (params.date) {
    const { type, value } = params.date;
    if (type === 'relative') {
      const date = new Date();
      switch (value) {
        case FILTER_DATE_ENUM.TODAY: {
          params.from = getStartUnix(date);
          params.to = getEndUnix(date);
          break;
        }
        case FILTER_DATE_ENUM.YESTERDAY: {
          date.setDate(date.getDate() - 1);
          params.from = getStartUnix(date);
          params.to = getEndUnix(date);
          break;
        }
        case FILTER_DATE_ENUM.THISMONTH: {
          const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          params.from = getStartUnix(firstDay);
          params.to = getEndUnix(lastDay);
          break;
        }
        case FILTER_DATE_ENUM.LASTMONTH: {
          date.setMonth(date.getMonth() - 1);
          const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
          const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          params.from = getStartUnix(firstDay);
          params.to = getEndUnix(lastDay);
          break;
        }
        default: {
          delete params.from;
          delete params.to;
          break;
        }
      }
    } else if (type === 'custom') {
      params.from = value.startOf('day').unix();
      params.to = value.endOf('day').unix();
    }
    delete params.date;
  }
  return request.get('v1/dashboard/income', { params });
}
